import { useEffect, useState } from 'react'

/**
 * Subscribe to a CSS media query. Returns whether it currently matches and
 * updates on viewport changes. SSR-safe (returns false until mounted).
 *
 *   const isNarrow = useMediaQuery('(max-width: 1023px)')
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
